/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from "react";
import Wrapper from "layout/Wrapper/Wrapper";
import asset from "json/assets";
import { Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomInput from "ui/CustomInput/CustomInput";
import CustomButton from "ui/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch } from "react-redux";
import {
  course_details,
  course_list,
  removeCourses,
  resetCourses,
  showSelectedList,
} from "redux/CourseSlice";
import {
  decryptSecretKey,
  getModalProperties,
  isNumeric,
} from "services/utils";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import validationText from "../../json/message/Validation";
import NoificationModal from "pages/ModalPage/NoificationModal";
import ModalWrapper from "layout/ModalWrapper/ModalWrapper";
import { country_list, range_create, state_list } from "redux/RangeInfoSlice";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BackdropLoader from "ui/BackdropLoader/BackdropLoader";
import useNotiStack from "hooks/useNotistack";
import CustomInputNoLabel from "ui/CustomInputNoLabel/CustomInputNoLabel";
import RangeInfoSkeleton from "ui/Skeletons/RangeInfoSkeleton";
import SideBarActions from "layout/SideBarActions/SideBarActions";
import { useAssociatedCourseData } from "hooks/RangeDetails";
import { useProfileData } from "hooks/ProfileDetails";
import { driving_range_gps_create } from "redux/MapSlice";
import { classification, status } from "json/constants";

import wrapperStyles from "styles/pages/Map1.module.scss";
import styles from "styles/pages/RangeInformation.module.scss";


const RangeInformation = () => {
  const modalProperties = getModalProperties();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { toastSuccess, toastError } = useNotiStack();
  const [statusopenBtn, setStatusopenBtn] = useState(false);
  const [courses, setCourses] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingCountryList, setLoadingCountryList] = useState(false);
  const [loadingStateList, setLoadingStateList] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [error, setError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [idcountryValue, setIdCountryValue] = useState();
  const [sideBarExpanded, setSideBarExpanded] = useState();
  const secret_Key = decryptSecretKey();
  const id_adminuser = localStorage.getItem("id_adminuser");
  const profileDetails = JSON.parse(localStorage.getItem("profile_data"));

  const profileData = useProfileData();
  const courseData = useAssociatedCourseData();

  // by id no of course
  const courseDetails = courseData?.course_details_data;
  // by name of course
  const activeCourseList = courseData?.course_list_data?.courseList;
  // const handleChange = (event) => {
  //   setAge(event.target.value);
  // };
  const handleRange = (e) => {
    setCourses(e.target.value);
  };

  // const classification = [
  //   { label: "Semi-private", value: "semi-private", id: "1" },
  //   { label: "Private", value: "private", id: "2" },
  //   { label: "Public",value: "public", id: "3" },
  //   { label: "Military",value: "military", id: "4" },
  //   { label: "Resort",value: "resort", id: "4" },
  // ];

  // const status = [
  //   { value: "Active", id: 1 },
  //   { value: "In active", id: 0 },
  // ];

  const handleRedirect = (data) => {
    setLoading(true);
    dispatch(
      course_details({
        body: {
          id_adminuser: id_adminuser,
          id_courseInt: parseInt(courses),
          stateFormat: 4,
          countryFormat: 4,
          detailLevel: 2,
          // id_course: courses
        },
        user: {
          secretKey: secret_Key,
          userName: profileData?.profile_information_data?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  const handleRedirectCourse = (data) => {
    if (courses && courses?.length >= 2) {
      setLoading(true);
    }
    dispatch(
      course_list({
        body: {
          id_adminuser: id_adminuser,
          courseName: courses,
          stateFormat: 4,
          page: 1,
          resultsPerPage: 100,
        },
        user: {
          secretKey: secret_Key,
          userName: profileData?.profile_information_data?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  let isNumericName = isNumeric(courses);
  useEffect(() => {
    if (courses && courses?.length > 0) {
      const delayDebounceFn = setTimeout(() => {
        if (isNumericName) {
          setError(false);
          handleRedirect();
        } else {
          if (courses && courses?.length < 2) {
            setError(true);
          } else {
            setError(false);
          }
          handleRedirectCourse();
        }
      }, 400);
      return () => clearTimeout(delayDebounceFn);
    } else {
      setCourses("");
      setError(false);
      //   setCourses(null);
      //   handleRedirect();
    }
  }, [courses]);

  const schema = yup.object().shape(
    {
      rangeName: yup
        .string()
        .trim()
        .required(validationText.error.rangeName)
        .min(3, validationText.error.rangeNameLenErr),
      address1: yup.string().trim().required(),
      city: yup.string().trim().required(),
      state: yup.number(),
      // state: yup.string().when("country", {
      //   is: (value) => value,
      //   then: (rule) =>
      //   stateData?.length !== 0 ? rule
      //       .required()
      //       // .oneOf([yup.ref("password"), null])
      //       .label("state") : rule,
      // }),
      country: yup.string().required(),
      latitude: yup.string().required(),
      longitude: yup.string().required(),
    },
    [
      // ["state", "state"],
      // ["country", "country"],
    ]
  );

  const {
    handleSubmit,
    control,
    getValues,
    reset,
    setValue,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const handleClickOpen = () => {
    if (isDirty === true) {
      setOpen(true);
    } else {
      navigate("/drivingrange");
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  const redirectToPage = () => {
    setOpen(false);
  };

  const navigateToDrivingRange = () => {
    navigate("/drivingrange");
  };

  let allCourseData = courseData?.showCourseList;
  let courseId = [];
  allCourseData &&
    allCourseData.map((e) => {
      courseId.push(e?.id_courseInt);
    });
  // sessionstore
  // let currentList = JSON.parse(sessionStorage.getItem("coursesData"));
  // currentList && currentList.map((e)=>{
  //   courseId.push(e?.id_courseInt);
  // })

  // id_courseName
  const addSelectCourseList = (e, selectedCourse) => {
    dispatch(showSelectedList(selectedCourse));
    // session
    // let newData = Object.values(currentList || {});
    // newData.push(selectedCourse);
    // if(courseId.includes(selectedCourse?.id_courseInt) !== true){
    // sessionStorage.setItem("coursesData", JSON.stringify(newData));
    // }
  };

  //  id_courseInt
  const addSelectCourseDetails = (e, selectedCourseDetail) => {
    dispatch(showSelectedList(courseDetails));
    // session
    // let newDetails = Object.values(currentList || {});
    // newDetails.push(courseDetails);
    // if(courseId.includes(courseDetails?.id_courseInt) !== true){
    //   sessionStorage.setItem("coursesData", JSON.stringify(newDetails));
    // }
  };

  const [currentListArray, setCurrentListArray] = useState([]);
  // redux stored data
  useEffect(() => {
    setCurrentListArray(allCourseData);
  }, [allCourseData, allCourseData?.length]);

  // session stored
  // useEffect(() => {
  //   if (currentList) {
  //     setCurrentListArray({ courses:[...currentList] })
  //   }
  // }, [
  //   currentList,
  //    currentList?.length]);

  //   session stored data clear session storage by refresh
  // window.addEventListener("beforeunload", function(e) {
  //   sessionStorage.clear("coursesData");
  // });

  // clear session storage if navigate to another page
  useEffect(() => {
    return () => {
      dispatch(resetCourses());
    };
  }, []);

  const handleRemove = (item) => {
    let filtered = currentListArray.filter(
      (e) => e.id_courseInt !== item.id_courseInt
    );
    // redux stored
    let filteredCourses = filtered;
    dispatch(removeCourses(filteredCourses));
    // sessionStorage....
    //   let filtered = currentListArray.courses.filter(
    //     (e) => e.id_courseInt !== item.id_courseInt
    //   );
    // setCurrentListArray({...currentListArray,courses:filtered})
    // let filteredCourses = filtered;
    // sessionStorage.setItem("coursesData",JSON.stringify(filteredCourses))
  };

  const handleSelectMenu = (e, selectedMenu) => {
    setIdCountryValue(selectedMenu?.id_country);
    setLoadingStateList(true);
    fetchStateList(selectedMenu?.id_country);
  };

  useEffect(() => {
    setLoadingCountryList(true);
    dispatch(
      country_list({
        body: {
          // id_adminuser: id_adminuser,
          // id_continent: "NA",
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        setCountryData(res?.payload?.data?.countryList);
        setLoadingCountryList(false);
      } else {
        // setLoadingCountryList(false);
        toastError("Something went wrong");
      }
    });
  }, []);

  useEffect(() => {
    reset({
      country: 840,
    });
    fetchStateList(840);
  }, []);

  const fetchStateList = (id_country) => {
    setValue("state", undefined);
    dispatch(
      state_list({
        body: {
          id_adminuser: id_adminuser,
          id_country: id_country || 840, // static id_country for usa
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        setStateData(res?.payload?.data?.stateList);
        setLoadingStateList(false);
      } else {
        setLoadingStateList(false);
      }
    });
  };

  const onSubmit = async (data) => {
    setSubmitLoading(true);
    const latLonpoints = [`${data?.latitude},${data?.longitude}`];
    dispatch(
      range_create({
        body: {
          // id_adminuser: id_adminuser,
          rangeName: data?.rangeName.trim(),
          address1: data?.address1.trim(),
          city: data.city.trim(),
          id_country: idcountryValue ? idcountryValue : 840,
          class: data.classification,
          address2: data.address2 && data.address2.trim(),
          id_state: data.state,
          otherState: data.otherState && data.otherState.trim(),
          zipCode: data.zip,
          phone: data.phone && data.phone.trim(),
          website: data.website && data.website.trim(),
          courseArray: courseId,
          // active: parseInt(data.status),
          active:data.status ? parseInt(data.status): 1
        },
        user: {
          secretKey: secret_Key,
          userName: profileDetails?.username,
        },
      })
    )?.then((res) => {
      if (res?.payload?.data?.Status === 1) {
        toastSuccess(res?.payload?.data?.ErrorMessage);
        setSubmitLoading(false);

        if (res?.payload?.data?.id_drivingRange) {
          let payload = {
            info: { id_drivingRange: res?.payload?.data?.id_drivingRange },
            shapes: {
              facilityMarker: [
                {
                  type: "point",
                  label: "FM1",
                  mod1: null,
                  mod2: null,
                  points: latLonpoints,
                },
              ],
            },
          };

          dispatch(
            driving_range_gps_create({
              body: { ...payload },
              user: {
                secretKey: secret_Key,
                userName: profileDetails?.username,
              },
            })
          );

          navigate("/drivingrange");
        }
      } else {
        setSubmitLoading(false);
        toastError("Network Error");
      }
    });
  };
  return (
    <div className="main_wraper">
      <Wrapper isHeader={true} headerTitle={'DRIVING RANGE'}>
        <div
            className={
              sideBarExpanded
                ? `${wrapperStyles.main_wrapper_flex}`
                : `${wrapperStyles.main_wrapper_flex} ${wrapperStyles.main_wrapper_flex_open}`
            }
          >
            <div className={wrapperStyles.main_left}>
              <div className={styles.sideBar}>
                <SideBarActions 
                  form='rangeInfo'
                  onCancelClick={handleClickOpen}
                  toggleSideBar={() => setSideBarExpanded(prev => !prev)} />
              </div>
            </div>
          <div className={wrapperStyles.main_rgt}>
            <div className={styles.range_sec}>
              <form id='rangeInfo' onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={0}>
                  <Grid item md={6} xs={12}>
                    <div className={styles.range_sec_box}>
                      {/* <form onSubmit={handleSubmit(onSubmit)}> */}
                      <div className={styles.range_head}>
                        <p>Add Range Information</p>
                      </div>

                      {loadingCountryList ? (
                        <RangeInfoSkeleton />
                      ) : (
                        <div className={`${styles.range_form} ${styles.range_form_cmn}`}>
                          <div className={styles.formSec}>
                            <Grid container spacing={0}>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                      <label>Range Name *</label>
                                    </Grid>
                                    <Grid item xs={7} md={7}>
                                      {errors?.rangeName?.message  && (
                                        <p className={styles.requiredContent}>
                                          {errors.rangeName.message}
                                        </p>
                                      )}
                                    </Grid>
                                  </Grid>
                                  <Controller
                                    control={control}
                                    name="rangeName"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInputNoLabel
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        disabled={submitLoading}
                                        // label="Range Name *"
                                        // error={Boolean(errors?.rangeName)}
                                        // helperText={errors?.rangeName?.message}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <label>CLASSIFICATION</label>
                                  <FormControl sx={{ m: 1, minWidth: 120 }}>
                                    <Controller
                                      control={control}
                                      name="classification"
                                      // {...register("classification")}
                                      render={({ field: { onChange, value } }) => (
                                        <Select
                                          defaultValue=""
                                          id="demo-simple-select"
                                          onChange={onChange}
                                          // value={value}
                                          value={value ? value : ""}
                                        >
                                          {classification.map((e) => {
                                            return (
                                              <MenuItem
                                                key={e?.id}
                                                value={e?.value}
                                              >
                                                {e?.label}
                                              </MenuItem>
                                            );
                                          })}
                                        </Select>
                                      )}
                                    />
                                  </FormControl>
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                      <label>ADDRESS 1*</label>
                                    </Grid>
                                    <Grid item xs={7} md={7}>
                                      {errors.address1 && (
                                        <p className={styles.requiredContent}>
                                          {validationText.error.address1}
                                        </p>
                                      )}
                                    </Grid>
                                  </Grid>
                                  <Controller
                                    control={control}
                                    name="address1"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInputNoLabel
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        disabled={submitLoading}
                                        // error={Boolean(errors?.address1)}
                                        // helperText={errors?.address1?.message}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  {/* <label>ADDRESS 2</label> */}
                                  <Controller
                                    control={control}
                                    name="address2"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInput
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        label="ADDRESS 2"
                                        disabled={submitLoading}
                                        // error={Boolean(errors?.address2)}
                                        // helperText={errors?.address2?.message}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                      <label>CITY *</label>
                                    </Grid>
                                    <Grid item xs={7} md={7}>
                                      {errors.city && (
                                        <p className={styles.requiredContent}>
                                          {validationText.error.city}
                                        </p>
                                      )}
                                    </Grid>
                                  </Grid>
                                  <Controller
                                    control={control}
                                    name="city"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInputNoLabel
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        label="CITY *"
                                        disabled={submitLoading}
                                        // error={Boolean(errors?.city)}
                                        // helperText={errors?.city?.message}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <label>STATE</label>
                                  <FormControl sx={{ m: 1, minWidth: 120 }}>
                                    {getValues("country") !== undefined ? (
                                      <>
                                        {loadingStateList && (
                                          <BackdropLoader open={true} />
                                        )}
                                        <Controller
                                          control={control}
                                          name="state"
                                          // {...register("state")}
                                          render={({
                                            field: { onChange, value },
                                          }) => (
                                            <>
                                              {stateData &&
                                              stateData?.length !== 0 ? (
                                                <Select
                                                  onChange={onChange}
                                                  defaultValue={value}
                                                  value={
                                                    value !== undefined && value
                                                  }
                                                >
                                                  {stateData.map((e, id) => {
                                                    return (
                                                      <MenuItem
                                                        value={e?.id_state}
                                                        key=""
                                                      >
                                                        {e?.stateFull}
                                                      </MenuItem>
                                                    );
                                                  })}
                                                </Select>
                                              ) : (
                                                <Select>
                                                  <MenuItem disabled>
                                                    - State not available -
                                                  </MenuItem>
                                                </Select>
                                              )}
                                            </>
                                          )}
                                        />
                                      </>
                                    ) : (
                                      <Select>
                                        <MenuItem disabled>
                                          - Select a country first -
                                        </MenuItem>
                                      </Select>
                                    )}
                                    {/* {errors.state && <p className={styles.requiredContent}>{validationText.error.state}</p> } */}
                                  </FormControl>
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  {/* <label>OTHER STATE</label> */}
                                  <Controller
                                    control={control}
                                    name="otherState"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInput
                                        label="OTHER STATE"
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        disabled={submitLoading}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  {/* <label>ZIP CODE</label> */}
                                  <Controller
                                    control={control}
                                    name="zip"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInput
                                        label="ZIP CODE"
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        disabled={submitLoading}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <Grid container spacing={2}>
                                    <Grid item xs={5} md={5}>
                                      <label>COUNTRY *</label>
                                    </Grid>
                                    <Grid item xs={7} md={7}>
                                      {errors.country && (
                                        <p className={styles.requiredContent}>
                                          {validationText.error.country}
                                        </p>
                                      )}
                                    </Grid>
                                  </Grid>

                                  <FormControl sx={{ m: 1, minWidth: 120 }}>
                                    {countryData && countryData?.length !== 0 ? (
                                      <Controller
                                        control={control}
                                        name="country"
                                        // {...register("country")}
                                        render={({
                                          field: { onChange, value },
                                        }) => (
                                          <Select
                                            id="demo-simple-select"
                                            onChange={onChange}
                                            // value={value}
                                            value={value ? value : ""}
                                          >
                                            {countryData &&
                                              countryData.map((e) => {
                                                return (
                                                  <MenuItem
                                                    value={e.id_country}
                                                    // onClick={handleSelectMenu}
                                                    onClick={(event) =>
                                                      handleSelectMenu(event, e)
                                                    }
                                                  >
                                                    {e?.countryFull}
                                                  </MenuItem>
                                                );
                                              })}
                                          </Select>
                                        )}
                                      />
                                    ) : (
                                      <Select>
                                        <MenuItem disabled>
                                          - Network Error -
                                        </MenuItem>
                                      </Select>
                                    )}
                                  </FormControl>
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  {/* <label>PHONE NUMBER</label> */}
                                  <Controller
                                    control={control}
                                    name="phone"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInput
                                        label="PHONE NUMBER"
                                        placeholder=""
                                        type="number"
                                        value={value}
                                        onChange={onChange}
                                        onKeyPress={(e) => {
                                          if (
                                            e.key === "e" ||
                                            e.key === "E" ||
                                            e.key === "-"
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                        onPaste={(e) => {
                                          e.preventDefault();
                                          return false;
                                        }}
                                        disabled={submitLoading}
                                        // error={Boolean(errors?.phone)}
                                        // helperText={errors?.phone?.message}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  {/* <label>WEBSITE</label> */}
                                  <Controller
                                    control={control}
                                    name="website"
                                    render={({ field: { onChange, value } }) => (
                                      <CustomInput
                                        label="WEBSITE"
                                        placeholder=""
                                        type="text"
                                        value={value}
                                        onChange={onChange}
                                        disabled={submitLoading}
                                      />
                                    )}
                                  />
                                </div>
                              </Grid>
                              <Grid item sm={6} xs={12}>
                                <div className={styles.formGroup}>
                                  <label>STATUS</label>
                                  <FormControl sx={{ m: 1, minWidth: 120 }}>
                                    <Controller
                                      control={control}
                                      name="status"
                                      // {...register("status")}
                                      render={({ field: { onChange, value } }) => (
                                        <Select
                                          defaultValue=""
                                          id="demo-simple-select"
                                          onChange={onChange}
                                          value={value ? value : ""}
                                        >
                                          {status.map((e) => {
                                            return (
                                              <MenuItem key={e?.id} value={e?.id}>
                                                {e?.value}
                                              </MenuItem>
                                            );
                                          })}
                                        </Select>
                                      )}
                                    />
                                    {/* {errors.status && <p className={styles.requiredContent}></p> } */}
                                  </FormControl>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                      )}
                      {/* </form> */}
                    </div>
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <div
                      className={`${styles.range_sec_box} ${styles.range_form_cmn}`}
                      // className={`${styles.range_sec_box} ${styles.latLon_none}`}
                    >
                      {/* <form onSubmit={handleSubmit(onSubmit)}> */}
                      <div className={styles.range_head}>
                        <p>Latitude and Longitude</p>
                      </div>
                      <div>
                        {/* <table className={styles.latlontable_bar}> */}
                        <div className={styles.formSec}>
                          <Grid container spacing={0}>
                            <Grid item sm={6} xs={12}>
                              <div className={styles.formGroup}>
                                <Grid container spacing={2}>
                                  <Grid item xs={5} md={5}>
                                    <label>Latitude* </label>
                                  </Grid>
                                  <Grid item xs={7} md={7}>
                                    {errors.latitude && (
                                      <p className={styles.requiredContent}>
                                        {validationText.error.latitude}
                                      </p>
                                    )}
                                    {/* {errors.latitude && <p className={styles.requiredContent}>{validationText.error.latitude}</p>} */}
                                  </Grid>
                                </Grid>
                                <Controller
                                  control={control}
                                  name="latitude"
                                  render={({ field: { onChange, value } }) => (
                                    <CustomInputNoLabel
                                      placeholder=""
                                      type="number"
                                      value={value}
                                      onChange={onChange}
                                      disabled={submitLoading}
                                      onKeyPress={(e) => {
                                        if (e.key === "e" || e.key === "E") {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  )}
                                />
                              </div>
                            </Grid>
                            <Grid item sm={6} xs={12}>
                              <div className={styles.formGroup}>
                                <Grid container spacing={2}>
                                  <Grid item xs={5} md={5}>
                                    <label>Longitude* </label>
                                  </Grid>
                                  <Grid item xs={7} md={7}>
                                    {errors.longitude && (
                                      <p className={styles.requiredContent}>
                                        {validationText.error.longitude}
                                      </p>
                                    )}
                                    {/* {errors.longitude && <p className={styles.requiredContent}>{validationText.error.longitude}</p>} */}
                                  </Grid>
                                </Grid>
                                <Controller
                                  control={control}
                                  name="longitude"
                                  render={({ field: { onChange, value } }) => (
                                    <CustomInputNoLabel
                                      placeholder=""
                                      type="number"
                                      value={value}
                                      onChange={onChange}
                                      disabled={submitLoading}
                                      onKeyPress={(e) => {
                                        if (e.key === "e" || e.key === "E") {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  )}
                                />
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        {/* </table> */}
                      </div>
                      {/* </form> */}
                    </div>
                    <div className={styles.Course_range_sec_box}>
                      <div className={styles.range_sec_inners}>
                        <div className={styles.range_head}>
                          <p>Associated Courses</p>
                          <button
                            type="button"
                            onClick={() => setStatusopenBtn(!statusopenBtn)}
                          >
                            <img src={asset.search1} alt="img" />
                          </button>
                          {statusopenBtn ? (
                            <div className={styles.click_dropdown}>
                              <div className={styles.search_box_drop}>
                                <input
                                  type="text"
                                  placeholder="Search course"
                                  value={courses}
                                  onChange={handleRange}
                                />
                                <button
                                  className={styles.close}
                                  onClick={() => setStatusopenBtn(!statusopenBtn)}
                                >
                                  <CloseIcon />
                                </button>
                              </div>
                              <div
                                className={styles.course_search_box_drop_cont}
                                // className={styles.search_box_drop_cont} // for full screen height
                              >
                                {loading && (
                                  <div style={{ color: "#146C94" }}>
                                    Loading Associated Courses...
                                  </div>
                                )}
                                {activeCourseList &&
                                activeCourseList?.length === 0 &&
                                loading !== true &&
                                !courseData?.course_details_data ? (
                                  <h5 className={styles.noDataAvailable}>
                                    {" "}
                                    No Course Found{" "}
                                  </h5>
                                ) : (
                                  <></>
                                )}
                                {/* {noDataShow && (<>   No Course Found</>)} */}
                                {error ? (
                                  <h5
                                    style={{
                                      marginTop: "3px",
                                      textAlign: "center",
                                      fontSize: "10px",
                                    }}
                                  >
                                    Enter at least 2 digit of course Name
                                  </h5>
                                ) : (
                                  <>
                                    {activeCourseList &&
                                    activeCourseList?.length !== 0 &&
                                    courses?.length !== 0 &&
                                    isNumericName === false ? (
                                      <ul>
                                        {loading !== true ? (
                                          <>
                                            {activeCourseList.map((e) => {
                                              return (
                                                <li
                                                  // className={courseId.includes(e?.id_courseInt) ? `${styles.disableSelect}` : `${styles.notDisableSelect}`}
                                                  // className={styles.addSelecteCourse}
                                                  onClick={
                                                    !courseId.includes(
                                                      e?.id_courseInt
                                                    )
                                                      ? (event) =>
                                                          addSelectCourseList(
                                                            event,
                                                            e
                                                          )
                                                      : null
                                                  }
                                                >
                                                  <h2>{e?.courseName}</h2>
                                                  <p>{e?.city}</p>
                                                  {courseId.includes(
                                                    e?.id_courseInt
                                                  ) ? (
                                                    <CheckCircleIcon />
                                                  ) : null}
                                                </li>
                                              );
                                            })}
                                          </>
                                        ) : null}
                                      </ul>
                                    ) : (
                                      <>
                                        {courseData?.course_details_data?.Status !==
                                          1 &&
                                        courses?.length !== 0 &&
                                        loading !== true ? (
                                          <h5 className={styles.noDataAvailable}>
                                            No related course found{" "}
                                          </h5>
                                        ) : (
                                          <ul>
                                            {loading !== true ? (
                                              <>
                                                {courseData?.course_details_data !==
                                                  null && isNumericName === true ? (
                                                  <li
                                                    onClick={
                                                      !courseId.includes(
                                                        courseData
                                                          ?.course_details_data
                                                          ?.id_courseInt
                                                      )
                                                        ? (event, e) =>
                                                            addSelectCourseDetails(
                                                              event,
                                                              e
                                                            )
                                                        : null
                                                    }
                                                  >
                                                    <h2>
                                                      {
                                                        courseData
                                                          ?.course_details_data
                                                          ?.courseName
                                                      }
                                                    </h2>
                                                    <p>
                                                      {
                                                        courseData
                                                          ?.course_details_data?.city
                                                      }
                                                    </p>
                                                    {courseId.includes(
                                                      courseData?.course_details_data
                                                        ?.id_courseInt
                                                    ) ? (
                                                      <CheckCircleIcon />
                                                    ) : null}
                                                  </li>
                                                ) : (
                                                  <></>
                                                )}
                                              </>
                                            ) : null}
                                          </ul>
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <div className={styles.course_range_table}>
                          <table className={styles.table_bar}>
                            {/* {currentListArray?.courses && currentListArray?.courses?.length !== 0 ? ( */}
                            {/* redux data */}
                            {currentListArray && currentListArray?.length !== 0 ? (
                              <>
                                <thead>
                                  <tr>
                                    <th className={styles.courseid}>COURSE ID</th>
                                    <th className={styles.coursename}>COURSE NAME</th>
                                    <th className={styles.address}>ADDRESS</th>
                                    <th className={styles.plus}></th>
                                  </tr>
                                </thead>
                                {/* {currentListArray?.courses?.map((e) => { */}
                                <tbody>
                                {currentListArray?.map((e, id) => {
                                  return (
                                    <>
                                      
                                        <tr key={e?.id_courseInt}>
                                          <td className={styles.courseid_cont}>
                                            {e?.id_courseInt}
                                            <div className={styles.tab_cont}>
                                              <p>{e?.courseName}</p>
                                              <p>
                                                {e?.city}, {e?.stateShort}
                                              </p>
                                            </div>
                                          </td>
                                          <td className={styles.coursename_cont}>
                                            {e?.courseName}
                                          </td>
                                          <td className={styles.address_cont}>
                                            {e?.address1} {e?.city}, {e?.stateShort}
                                          </td>
                                          <td>
                                            <div className={styles.remove_btn}>
                                              <div className={styles.plus_cont}>
                                                <span onClick={() => handleRemove(e)}>
                                                  <img src={asset.close} alt="img" />{" "}
                                                </span>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      
                                    </>
                                  );
                                })}
                                </tbody>
                              </>
                            ) : (
                              <p className={styles.noDataForCourse}>
                                No Associated Courses
                              </p>
                            )}
                          </table>
                        </div>
                      </div>
                    </div>
                    {/* <form onSubmit={handleSubmit(onSubmit)}> */}
                    {/* </form> */}
                  </Grid>
                    <ModalWrapper
                      open={open}
                      onClose={handleClose}
                      handleClose={handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <NoificationModal
                        label="Warning"
                        backgroundColor={modalProperties.warning.backgroundColor}
                        image={modalProperties.warning.icon}
                        title="Range details are not saved."
                        // content="Are you sure you want to exit?"
                        content="Do you really want to exit?"
                        rejCallBack={redirectToPage}
                        affrCallBack={navigateToDrivingRange}
                      />
                    </ModalWrapper>
                </Grid>
              </form>
            </div>
          </div>
      </div>
      </Wrapper>
    </div>
  );
};

export default RangeInformation;

// {"info":{"id_drivingRange":"KqR94OKMKosZ"},
// "shapes" : {
// "facilityMarker":[{"type":"point","label":"FM1","mod1":null,"mod2":null,"points":["47.252210770704224,-101.78312122821809"]}],

// }}
